import { EnvironmentProviders, Provider } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '@environment';
import { logoutMetaReducer } from '@app/core/authentication/store/auth.metareducer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideStore } from '@ngrx/store';
import { WINDOW_PROVIDER } from '@app/core/providers/window/window.provider';
import { NAVIGATOR_PROVIDER } from '@app/core/providers/navigator/navigator.provider';

export function provideCoreDependencies(): (Provider | EnvironmentProviders)[] {
  return [
    DialogService,
    MessageService,
    WINDOW_PROVIDER,
    NAVIGATOR_PROVIDER,
    provideStore(undefined, {
      metaReducers: [logoutMetaReducer],
    }),
    provideStoreDevtools({ maxAge: 25, logOnly: environment.production }),
  ];
}
